import { type WalletWithTotalAmountDTO } from '@capsicum/common';
import { useWalletQuery } from '@capsicum/socios-core';
import { type QueryObserverOptions } from '@tanstack/react-query';
import { useCallback } from 'react';

/**
 * @returns An array of all WalletLedger objects from the wallet data.
 */
export const useWalletLedgers = (options?: QueryObserverOptions) => {
	const walletLedgersReducer = useCallback((data: undefined | WalletWithTotalAmountDTO) => data?.ledgers ?? [], []);

	return useWalletQuery(walletLedgersReducer, options);
};
